import {
  Form,
  ICONS,
  Icon,
  PLATFORM_THEME_COLORS,
  TextInput,
  ButtonsWrapper,
  Button,
  ColorSelect,
  DeleteModal,
} from '@thinknet-gmbh/platform-common-ui';
import { DEFAULT_NAME_FIELD_REGEX } from '@thinknet-gmbh/platform-common';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DeleteContainer,
  InputContainer,
} from 'src/pages/settings/components/company-settings/components/common-box-expand/common-box-expand.styles';
import { IEditComponentProps } from 'src/pages/settings/components/company-settings/components/common-box-expand/common-box-expand.interfaces';

const CommonBoxExpandEdit = ({
  fields,
  remove,
  closeEdit,
  requiredMessage,
  inputPlaceholder,
  formItemLabel,
  formItemName,
  colorSelectLabel,
  colorSelectName,
  data,
  colorSelectPlaceholder,
  onSubmitDelete,
}: IEditComponentProps) => {
  const { t } = useTranslation(['common', 'settings']);
  const [isOpenedDeleteModal, setIsOpenedDeleteModal] = useState(false);
  const [removeKey, setRemoveKey] = useState({ key: 999, fieldName: '' });

  const onSubmitDeleteModal = () => {
    if (onSubmitDelete) {
      const target = data[removeKey.key];
      onSubmitDelete(target);
    }

    remove(removeKey.key);
    setIsOpenedDeleteModal(false);
  };

  return (
    <>
      <InputContainer>
        {isOpenedDeleteModal && (
          <DeleteModal
            title={t('settings:companySettings.deleteModal.title')}
            subTitle={t('settings:companySettings.deleteModal.subtitle', {
              fieldName: removeKey.fieldName,
            })}
            isOpened={isOpenedDeleteModal}
            onClose={() => setIsOpenedDeleteModal(false)}
            onSubmit={onSubmitDeleteModal}
            translate={t}
          />
        )}
        {fields.map(field => (
          <div key={field.key}>
            <DeleteContainer key={field.key}>
              <Form.Item
                name={[field.name, formItemName || '']}
                label={formItemLabel}
                rules={[
                  {
                    required: true,
                    message: requiredMessage,
                  },
                  {
                    pattern: DEFAULT_NAME_FIELD_REGEX,
                    message: t('common:validation.error.incorrectFormat'),
                  },
                ]}
              >
                <TextInput placeholder={inputPlaceholder} maxLength={50} />
              </Form.Item>
              <Icon
                icon={ICONS.trash}
                size={22}
                color={PLATFORM_THEME_COLORS.tone.red}
                rightMargin={false}
                onClick={() => {
                  const fieldName = data[field.name];
                  if (fieldName) {
                    setIsOpenedDeleteModal(true);
                    setRemoveKey({ key: field.name, fieldName: fieldName[formItemName || ''] });
                    return;
                  }
                  remove(field.name);
                }}
              />
            </DeleteContainer>
            {colorSelectName && (
              <Form.Item
                name={[field.name, colorSelectName]}
                label={colorSelectLabel}
                rules={[{ required: true, message: t('common:validation.error.incorrectFormat') }]}
              >
                <ColorSelect translate={t} placeholder={colorSelectPlaceholder} />
              </Form.Item>
            )}
          </div>
        ))}
      </InputContainer>
      <ButtonsWrapper>
        <Button type="primary" htmlType="submit">
          {t('common:buttons.save')}
        </Button>
        <Button onClick={closeEdit}>{t('common:buttons.cancel')}</Button>
      </ButtonsWrapper>
    </>
  );
};

export default CommonBoxExpandEdit;
